import { render, staticRenderFns } from "./imageScroll.vue?vue&type=template&id=ebd53f5c&scoped=true"
import script from "./imageScroll.vue?vue&type=script&lang=js"
export * from "./imageScroll.vue?vue&type=script&lang=js"
import style0 from "./imageScroll.vue?vue&type=style&index=0&id=ebd53f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd53f5c",
  null
  
)

export default component.exports